import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "@/components/feature/Logo";
import { track } from "@/lib/analytics";

const SIGNUP_URL = "https://app.joble.app/auth/create-account?free=true";

const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Products", href: "/products" },
  { label: "About", href: "https://joble.app/en/company" },
];

export default function ContentHeader() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 left-0 right-0 z-50 bg-background-50/85 backdrop-blur-md border-b border-background-300/25">
      <nav className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <Logo imgClassName="h-7 md:h-8" />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((link) =>
              link.href.startsWith("/") ? (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`text-sm transition-colors cursor-pointer whitespace-nowrap ${
                    pathname === link.href
                      ? "font-semibold text-foreground-950"
                      : "font-medium text-foreground-800 hover:text-foreground-950"
                  }`}
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.href}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm font-medium text-foreground-800 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              )
            )}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href={SIGNUP_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("try_joble_clicked", { location: "content_header_desktop" })}
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 text-foreground-950 text-sm font-semibold px-5 py-2.5 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Try Joble Now
              <i className="ri-arrow-right-line" aria-hidden></i>
            </a>
          </div>

          <button
            type="button"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950 cursor-pointer"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden></i>
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-6 pt-2 animate-fadeIn">
            <div className="flex flex-col gap-1">
              {NAV_LINKS.map((link) =>
                link.href.startsWith("/") ? (
                  <Link
                    key={link.href}
                    to={link.href}
                    onClick={() => setOpen(false)}
                    className={`text-sm py-2.5 cursor-pointer ${
                      pathname === link.href
                        ? "font-semibold text-foreground-950"
                        : "font-medium text-foreground-800 hover:text-foreground-950"
                    }`}
                  >
                    {link.label}
                  </Link>
                ) : (
                  <a
                    key={link.href}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setOpen(false)}
                    className="text-sm py-2.5 font-medium text-foreground-800 hover:text-foreground-950 cursor-pointer"
                  >
                    {link.label}
                  </a>
                )
              )}
            </div>
            <a
              href={SIGNUP_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("try_joble_clicked", { location: "content_header_mobile" })}
              className="mt-4 text-center rounded-md bg-primary-500 text-foreground-950 text-sm font-semibold px-5 py-3 cursor-pointer block"
            >
              Try Joble Now
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}